import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import { Context, subjectRegistrationPath } from "../../../managerStore";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { titles } from "../../../constants/titles";

import styles from "./Subjects.module.scss";

const Subjects = () => {
  const { state } = useContext(Context);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  const teachers = state.teachers.map(teacher => {
    const subjects =
      state.teacher_subjects_by_school.find(
        teacherSubject => teacherSubject.teacher_id === teacher.id,
      )?.subjects ?? [];

    return {
      ...teacher,
      subjects,
    };
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className="me-4 mb-0">{titles.subjects}</h3>
        <p>{currentYear}年度LOUNGEを利用する先生の教科を登録してください。</p>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>名前</th>
            <th className={styles.subjectAndClassHeading}>
              <span className={styles.heading}>教科</span>
              <span className={styles.heading}>教科担当クラス</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {teachers.map(teacher => (
            <tr key={teacher.id}>
              <td>{teacher.id}</td>
              <td className={styles.teacherName}>
                {teacher.last_name} {teacher.first_name}
              </td>
              <td className={styles.subjectAndClass}>
                <div className={styles.subjectBlock}>
                  <ul className={styles.list}>
                    {teacher.subjects.map(subject => (
                      <li className={styles.item} key={subject.subject_id}>
                        <div className={styles.subjectName}>
                          {subject.subject_name}
                        </div>
                        <ul className={styles.classList}>
                          {subject.klasses.map((klass, index) => (
                            <li key={klass.klass_id}>
                              {klass.klass_name}
                              {index < subject.klasses.length - 1 && "、　"}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </td>
              <td className={clsx("text-center", styles.utilBtnArea)}>
                <button
                  className={"btn btn-outline"}
                  onClick={() =>
                    history.push(`${subjectRegistrationPath}/${teacher.id}`)
                  }
                >
                  教科登録
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Subjects;
